import get from "lodash.get";
import paths from "routes/paths";

class UserUtils {
  static getFullName = (userState) => {
    if (!userState) {
      return "";
    }

    const { user } = userState;

    if (!user) {
      return "";
    }

    return `${user.firstname} ${user.lastname}`;
  };

  static isEmailValid = (email = "") => {
    const emailRegex = new RegExp(
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/
    );
    return email.match(emailRegex);
  };

  static getDefaultRoute = (user) => {
    if (!get(user, "initialized")) {
      return get(paths, "front.login");
    }

    let defaultRoute = get(user, "user.default_tab", "");
    return get(paths, `front.${defaultRoute}`, get(paths, "front.home", "/"));
  };
}

export default UserUtils;
